import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const ozodeldConfig: TSPConfig = {
  key: 'ozodeld',
  name: 'OzodELD',
  imageName: 'OzodELD',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API key from OzodELD support, then enter it below.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default ozodeldConfig;
